import { styled, media } from "@payright/web-components";

export const SCCustomerFilterStatement = styled.div`
  max-width: 1200px;
  width: 100%;
  margin: 1em auto 0;
  height:vh;

  ${media.max.medium} {
    max-width: 1500px;
  }

  .containerStatement {
    display: flex;
    flex-direction: row;
    align-items: flex-end;
    width: 100%;
    justify-content: flex-end;
    margin: 1em auto 0;

    gap: 10px;

    .loanNumberDropdown {
      max-width: 200px;
    }
    
    .mobileStatementButton{
      display: none;
    }
    
    .export-btn {
      height: 47px;
    }

    ${media.max.medium} {
      flex-direction: column;
      align-items: stretch;
      row-gap: 20px;
      width: fit-content;


      .mobileStatementButton{
        font-size: 0.9em;
        display: block;
        width: auto;
        z-index: 0;
      }

      .mobileStatementButton button.export-btn {
        width: initial;
      }
      
      .loanNumberDropdown {
        display: block;
        font-size: 0.8em;
        max-width: 337px;
      }

      .statementButton {
        display: none;
      }
    }
  }
`;

export const SCCustomerDateError = styled.div`
  max-width: 1200px;
  width: 100%;
  margin: 1em auto 0;
  text-align: center;
  color: ${props => props.theme.colours.blue.base};
  font-size: 1.1em;
  font-weight: bold;
`;
export const Statement = styled.div`
  font-family: Arial, monospace;
`;

export const SCShowExportPDF = styled.div`
  .pdfMainContent {
    padding-top: 1em;
    object {
      width: 100%;
      height: 100vh !important;
    }
    ${media.max.medium} {
      object {
        display: none;
      }
    }
  }
`;
